import React from 'react'
import to from './assets/ternary_operator.jpg'
const T_o = () => {
    return (
        <div className='container'>
            <h1>Ternary Operator</h1>
            <p>If any operator is used on three operands or variable is known as Ternary Operator. It can be represented with ? : . It is also called as conditional operator
<br />
It helps to think of the ternary operator as a shorthand way or writing an if-else statement. Programmers use the ternary operator for decision making in place of longer if and else conditional statements.
<br />
The ternary operator is an operator that takes three arguments. The first argument is a comparison argument, the second is the result upon a true comparison, and the third is the result upon a false comparison. Ternary operator is shortened way of writing an if-else statement.
<br />
Ternary operator is a?b:c it say that the condition a is true b will be executed else c will be executed. <br /></p>
<img src={to} alt="" />
<p> In the above symbol expression-1 is condition and expression-2 and expression-3 will be either value or variable or statement or 
    any mathematical expression. If condition will be true expression-2 will be execute otherwise expression-3 will be executed.</p>
<h3>Advantage of Ternary Operator</h3>
<p>Using <b> ?:</b> reduce the number of line codes and improve the performance of application.</p> 
<h3>Syntax</h3>
<div className='containers'>
expression-1 ? expression-2 : expression-3</div>
<h3>Example-Find Largest Number among 3 Number in C</h3>
<div className='containers'>
<code class="library">#include &lt;stdio.h&gt;</code> <br />
<code class="library">#include &lt;conio.h&gt;</code> <br />
<codes className='keywords'> void</codes> main()<br />
&#123;<br />
    <codes className='keywords'>int</codes> a, b, c, large;<br />
clrscr();<br />
<codes className='keywords'>printf</codes>("Enter any three number: ");<br />
<codes className='keywords'>scanf</codes>("%d%d%d",&a,&b,&c);<br />
large=a&gt;b ? (a&gt;c?a:c) : (b&gt;c?b:c);<br />
<codes className='keywords'>printf</codes>("Largest Number is: %d",large);<br />
getch();<br />
&#125;
</div>
<h3>Output</h3>
<div className='output'>
Enter any three number: 5 7 2 <br />
Largest number is 7
</div>
        </div>
    )
}

export default T_o
